import GiftInfoAlpha from './alpha.jsx'
import GiftInfoBeta from './beta.jsx'

export const Alpha = GiftInfoAlpha
export const Beta = GiftInfoBeta
